<script>
import RenderNode from './RenderNode.vue';

export default {
  name: 'Carousel',
  components: {
    RenderNode,
  },
  props: {
    totalTiles: {
      type: Number,
      required: true,
    },
    tilesPerSlide: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      required: true,
    },
    carouselHeight: {
      type: Number,
      default: 100,
    },
    gap: {
      type: Number,
      default: 10,
    },
    link: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      state: {
        currentFirstTile: 0,
        currentLastTile: this.tilesPerSlide - 1,
        isFirstSlide: true,
        slideIndex: 1,
        isLastSlide: this.tilesPerSlide >= this.totalTiles,
        showNavigation: this.totalTiles > this.tilesPerSlide,
      },
      tiles: this.$slots.default,
      headerHeight: 62,
    };
  },
  methods: {
    decrementSlideIndex() {
      if (this.state.isFirstSlide) return;

      this.state.slideIndex--;
      this.state.isFirstSlide = this.state.currentFirstTile - this.tilesPerSlide <= 0;
      this.state.currentFirstTile = this.state.isFirstSlide ? 0 : this.state.currentFirstTile - this.tilesPerSlide;

      this.state.isLastSlide = false;
      this.state.currentLastTile = this.state.currentFirstTile + this.tilesPerSlide - 1;
    },
    incrementSlideIndex() {
      if (this.state.isLastSlide) return;

      this.state.slideIndex++;
      this.state.isLastSlide = this.state.currentLastTile + this.tilesPerSlide + 1 >= this.totalTiles;
      this.state.currentLastTile = this.state.isLastSlide
        ? this.totalTiles - 1
        : this.state.currentLastTile + this.tilesPerSlide;

      this.state.isFirstSlide = false;
      this.state.currentFirstTile += this.tilesPerSlide;
    },
  },
};
</script>

<template>
  <div :style="{ maxHeight: `${carouselHeight + headerHeight}px`}" class="carousel-container">
    <div class="carousel-header__wrapper">
      <a :href="link" class="carousel-header__title-link">
        <h2 class="carousel-header__title">{{ title }}</h2>
      </a>
      <div v-if="state.showNavigation" class="carousel-header__navigation">
        <button
          :class="{ disabled: state.isFirstSlide }"
          class="carousel-header__navigation-item carousel-header__navigation-item--prev"
          @click="decrementSlideIndex()"
        ></button>
        <button
          :class="{ disabled: state.isLastSlide }"
          class="carousel-header__navigation-item carousel-header__navigation-item--next"
          @click="incrementSlideIndex()"
        ></button>
      </div>
    </div>
    <transition-group name="fade">
      <div :key="state.slideIndex" class="carousel-tiles__wrapper">
        <template v-for="(tile, index) in tiles">
          <RenderNode
            :key="index"
            :node="tile"
            :class="{
              'carousel-tile--hide-desktop': index < state.currentFirstTile || index > state.currentLastTile,
              'carousel-tile--no-margin': index === state.currentLastTile
            }"
            :style="{ flexBasis: `${(100 / tilesPerSlide).toFixed(3)}%`, marginRight: `${gap}px`}"
            class="carousel-tile"
          />
        </template>
      </div>
    </transition-group>
  </div>
</template>
